












import { Component, Prop, Vue } from 'vue-property-decorator';
import BillingProfileView from '@/components/account/BillingProfileView.vue';
import AccountProfileBillingAddress from '@/components/account/AccountProfileBillingAddress.vue';
import { AccountProfileComponents } from '@/enums/AccountProfileComponents';
import { BillingAddress } from '@/interfaces/BillingAddress';
import { UserData } from '@/interfaces/UserData';

@Component({
    name: 'BillingProfile',
    components: {
        BillingProfileView,
        AccountProfileBillingAddress
    },
})
export default class BillingProfile extends Vue {
    @Prop({required: true}) public billingAddresses!: BillingAddress[];
    @Prop({required: true}) public userData!: UserData;

    protected currentActiveComponent = AccountProfileComponents.Addresses;
    protected editableBillingAddress: BillingAddress | null = null;

    protected onToggleComponent(component: AccountProfileComponents, billingAddress: BillingAddress) {
        this.editableBillingAddress = billingAddress;
        this.currentActiveComponent = component;
    }

    protected beforeDestroy() {
        this.currentActiveComponent = AccountProfileComponents.Addresses;
    }

    protected navigateToComponent(componentName: string) {
        this.$emit('navigate', componentName);
    }
}
